import { extractJsonObject } from "../outline/outlinePrompt.js";
import { updateSlideInDeck } from "../editor/deckEditor.js";
import { bedrockConverseWithImage } from "./bedrockVision.js";
const SALIENCY_SYSTEM = `You analyze a 16:9 presentation slide BACKGROUND image (no text widgets).
Return ONLY valid JSON:
{"freeZones":[{"x":0.0,"y":0.0,"w":0.0,"h":0.0}],"busyRegions":[{"x":0.0,"y":0.0,"w":0.0,"h":0.0}]}
Coordinates normalized 0..1. freeZones = calm low-detail areas suitable for text overlay. busyRegions = visually dense areas.
Do NOT return text labels or per-widget coordinates. 1-3 zones each.`;
function normalizeZone(raw) {
    if (!raw || typeof raw !== "object")
        return null;
    const o = raw;
    const x = Number(o.x);
    const y = Number(o.y);
    const w = Number(o.w);
    const h = Number(o.h);
    if (![x, y, w, h].every((n) => Number.isFinite(n)))
        return null;
    if (w <= 0.05 || h <= 0.05)
        return null;
    return {
        x: Math.max(0, Math.min(1, x)),
        y: Math.max(0, Math.min(1, y)),
        w: Math.max(0.05, Math.min(1, w)),
        h: Math.max(0.05, Math.min(1, h)),
    };
}
function parseSaliencyResponse(raw) {
    const obj = extractJsonObject(raw);
    if (!obj)
        throw new Error("Saliency: risposta non JSON.");
    const freeZones = (Array.isArray(obj.freeZones) ? obj.freeZones : [])
        .map(normalizeZone)
        .filter((z) => z !== null)
        .slice(0, 3);
    const busyRegions = (Array.isArray(obj.busyRegions) ? obj.busyRegions : [])
        .map(normalizeZone)
        .filter((z) => z !== null)
        .slice(0, 3);
    if (!freeZones.length)
        throw new Error("Saliency: freeZones mancanti.");
    return { freeZones, busyRegions };
}
export async function analyzeSlideBackgroundSaliency(cfg, backgroundDataUrl) {
    const raw = await bedrockConverseWithImage(cfg, {
        feature: "surf.slide.saliency",
        systemText: SALIENCY_SYSTEM,
        userText: "Identify free calm zones and busy regions for text overlay planning.",
        imageDataUrl: backgroundDataUrl,
    });
    return parseSaliencyResponse(raw);
}
export function setSlideBackgroundSaliency(deck, slideId, zones) {
    return updateSlideInDeck(deck, slideId, (slide) => ({
        ...slide,
        background: {
            ...slide.background,
            freeZones: zones.freeZones,
            busyRegions: zones.busyRegions,
        },
    }));
}
/** Best-effort saliency — never throws to caller. */
export async function tryAnalyzeSlideSaliency(cfg, backgroundDataUrl) {
    try {
        return await analyzeSlideBackgroundSaliency(cfg, backgroundDataUrl);
    }
    catch {
        return null;
    }
}
